/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesconfirm1Inputs */

const en_filesconfirm1 = /** @type {(inputs: Filesconfirm1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Confirm`)
};

const pt_filesconfirm1 = /** @type {(inputs: Filesconfirm1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Confirmar`)
};

/**
* | output |
* | --- |
* | "✓ Confirm" |
*
* @param {Filesconfirm1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesconfirm1 = /** @type {((inputs?: Filesconfirm1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesconfirm1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesconfirm1(inputs)
	return pt_filesconfirm1(inputs)
});
export { filesconfirm1 as "filesConfirm" }